import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Routes } from "@angular/router";
import { authOrigins } from "../shared/auth/auth-origins";

@Component({
  standalone: true,
  template: "<p>Opening FlockFinder…</p>",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
class OpenAppPage {
  constructor() {
    window.location.replace(authOrigins().app + window.location.pathname + window.location.search);
  }
}

export const LOGIN_ROUTES: Routes = [
  {
    path: "native/browser",
    data: { browserOnly: true },
    loadComponent: () => import("./native-browser-handoff.page").then(m => m.NativeBrowserHandoffPage),
  },
  {
    path: "native/prepare",
    loadComponent: () => import("./native-browser-handoff.page").then(m => m.NativeBrowserHandoffPage),
  },
  {
    path: "native/authorise",
    data: { authorising: true },
    loadComponent: () => import("./native-browser-handoff.page").then(m => m.NativeBrowserHandoffPage),
  },
  { path: "_/dashboard", loadComponent: () => import("./dashboard-handoff.page").then(m => m.DashboardHandoffPage) },
  { path: "", pathMatch: "full", redirectTo: "welcome/login" },
  {
    path: "welcome",
    pathMatch: "full",
    loadComponent: () => import("../welcome/welcome.page").then(m => m.WelcomePage),
  },
  { path: "welcome/login", loadComponent: () => import("../welcome/login/login.page").then(m => m.LoginPage) },
  {
    path: "welcome/signup",
    pathMatch: "full",
    loadComponent: () => import("../welcome/signup/signup.page").then(m => m.SignupPage),
  },
  {
    path: "welcome/signup/confirmation",
    loadComponent: () => import("../welcome/signup/confirmation/confirmation.page").then(m => m.ConfirmationPage),
  },
  {
    path: "welcome/email-verified",
    loadComponent: () => import("../welcome/email-verified/email-verified.page").then(m => m.EmailVerifiedPage),
  },
  { path: "auth/action", loadComponent: () => import("./email-action.page").then(m => m.EmailActionPage) },
  {
    path: "auth/continue",
    data: { kind: "continue" },
    loadComponent: () => import("./auth-utility.page").then(m => m.AuthUtilityPage),
  },
  {
    path: "billing",
    data: { kind: "billing" },
    loadComponent: () => import("./auth-utility.page").then(m => m.AuthUtilityPage),
  },
  {
    path: "sign-out",
    data: { kind: "logout" },
    loadComponent: () => import("./auth-utility.page").then(m => m.AuthUtilityPage),
  },
  { path: "**", component: OpenAppPage },
];
